export enum EPaymentType {
    DEBIT = 'DEBIT',
    CREDIT = 'CREDIT',
    PIX = 'PIX',
    BOLETO = 'BOLETO',
    PERMUTA = 'PERMUTA',
    GRATIS = 'GRATIS',
}